export default "__VITE_ASSET__CCV5BmKT__"